    
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Watch } from "vue-property-decorator";
    import { ICertificateSuggestion, CertificateSuggestion } from "@/model/CertificateSuggestion";
    import apiClient from "@/stuff/ApiClient";
    import toastr from "toastr";

    @Component({ })
    export default class CertifcateSuggestions extends Vue {

        //
        // -- properties
        //
        
        private itemsPerPage: number = 50;
        private get headers(): Array<any> {
            return [
                { key: "supplier", label: "Supplier" },
                { key: "certificate", label: "Certificate" },
                { key: "scope", label: "Scope" },
                { key: "created", label: "Suggested Date" },
                { key: "actions", label: "", width: "50px" }
            ]
        }
        
        private page: number = 1;
        private certificates: Array<CertificateSuggestion> = [];
        private totalCount: number|null = null;

        get countText(): string { return this.totalCount == null ? "..." : this.totalCount.toString(); }

        //
        // -- watchers
        //
        
        @Watch("page")
        onPageChanged():void {
            this.search();
        }

        //
        // -- methods
        //
        
        async mounted():Promise<void> {
            this.search();
        }

        async search():Promise<void> {
            const response: { count: number, list: Array<ICertificateSuggestion> } = await apiClient.get(`api/certificate/suggestions/${this.page}`);
            this.totalCount = response.count;
            this.certificates.length = 0;
            this.certificates.push(...response.list.map((c: ICertificateSuggestion) => new CertificateSuggestion(c)));
        }

        private goToSupplier(item: CertificateSuggestion) {
            const route = { 
                path: `/Supplier/${item.supplierID}?goToTab=modules`,
                query: { goToTab: "modules" }
            };
            window.open(route.path, "_blank");
        }

        private async deleteItem(item: CertificateSuggestion, event: Event) {
            const shouldDelete: boolean = await this.$bvModal.msgBoxConfirm("Are you sure you want to dimiss this suggestion?", {
                title: "Dimiss Suggestion",
                okVariant: "danger",
                okTitle: "Yes",
                cancelTitle: "No",
                hideHeaderClose: true,
                centered: true,
                headerClass: "border-bottom-0",
                footerClass: "border-top-0",
                size: "sm"
            });

            if (!shouldDelete) return;

            const response = await apiClient.get(`/api/certificate/suggestion/delete/${item.id}`, event);
            toastr.warning(response.message === "ok" ? "Deleted": "Failed to delete");
            this.search();
        }

    }

